const getUTSIsoString = (date: Date | undefined) => {
  if (typeof date !== "object") {
    return date;
  }

  function pad(number) {
    if (number < 10) {
      return "0" + number;
    }
    return number;
  }

  return (
    date.getUTCFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds()) +
    "." +
    (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
    "Z"
  );
};

export default getUTSIsoString;
